// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__30eS9","content":"LayoutSettings_content__37BOh"};